import './headerTop.scss';

import { lazy, Suspense, useState, useEffect } from 'react';
// Закомментируем прямой импорт и добавим ленивую загрузку
// import { TopDrop } from '../top-drop/topDrop';
// Исправляем импорт для именованного экспорта
const LazyTopDrop = lazy(() => 
  import('../top-drop/topDrop').then(module => ({ default: module.TopDrop }))
);

import icon_online from '../../../scss/images/icon-online-people.svg';
import icon_top from '../../../scss/images/icon-top.svg';
import icon_top2 from '../../../scss/images/icon-top-2.svg';
import { FunctionComponent } from 'react';
import { useConfig, useGetStatistics } from '~frontend/components/hooks';
import { useTranslation } from 'react-i18next';
import TopDropSkeleton from '../../skeletons/TopDropSkeleton';
import OnlineSkeleton from '../../skeletons/OnlineSkeleton';

// Компонент для отображения блока Online
const OnlineBlock: FunctionComponent = () => {
  const { t } = useTranslation();
  const { data: { getStatistics } = {} } = useGetStatistics();
  
  return (
    <div className="header_online">
      <img
        className="header_online_img"
        src={icon_online}
        alt="online"
        width={21}
        height={21}
      />
      <span className="header_online_count">
        {getStatistics?.online}
      </span>
      <span className="header_online_text">{t('Online')}</span>
    </div>
  );
};

export const HeaderTop: FunctionComponent = () => {
  const getConfig = useConfig();
  const [showTopDrop, setShowTopDrop] = useState(false);
  const [showOnline, setShowOnline] = useState(false);

  const isMobile =
    getConfig?.userAgent.match(
      /Android|BlackBerry|iPhone|iPod|Opera Mini|IEMobile|WPDesktop/i,
    ) ?? false;

  // Добавляем эффект для отображения скелетонов
  useEffect(() => {
    const topDropTimer = setTimeout(() => {
      setShowTopDrop(true);
    }, 1000);

    const onlineTimer = setTimeout(() => {
      setShowOnline(true);
    }, 800);

    return () => {
      clearTimeout(topDropTimer);
      clearTimeout(onlineTimer);
    };
  }, []);

  return (
    <div className="header_top">
      {!isMobile && (
        showOnline ? <OnlineBlock /> : <OnlineSkeleton />
      )}

      {/* <div className="header_top_change">
        <div className="header_top_change_item">
          <img src={icon_top} alt="arrow" width={24} height={24} />
        </div>
        <div className="header_top_change_item">
          <img src={icon_top2} alt="arrow" width={24} height={24} />
        </div>
      </div> */}
      
      {showTopDrop ? (
        <Suspense fallback={<TopDropSkeleton />}>
          <LazyTopDrop />
        </Suspense>
      ) : (
        <TopDropSkeleton />
      )}
    </div>
  );
};
